class kukunRange {
    constructor(range_input, parameters) {
        this.element = range_input;
        this.min = this.element.min;
        this.max = this.element.max;
        this.value = this.element.value;
        this.rangeWrapper = this.element.parentElement;
        this.rangeInputNumber = this.rangeWrapper.children[1].children[0]
        this.range_params = parameters;
        this._addParameters();
        this._loadEvents();
    }

    _loadEvents() {
        this.element.addEventListener('input', this.handleRangeValue.bind(this))

        this.range_value.children[0].addEventListener('input', this.handleInputValue.bind(this))

        this.element.addEventListener('mouseover', this.changebg.bind(this))

        this.element.addEventListener('mouseout', this.defaultbg.bind(this))

        this.element.addEventListener('input', this.activeDrag.bind(this))

        this.getHeightOfLabel()

        this.disableRange()
    }
    _addParameters() {
        if(!this.range_params.color) {
            this.range_params.color = '#1A92EA'
        }

        if(!this.range_params.backgroundColor) {
            this.range_params.backgroundColor = '#3DADFF'
        }


        if(!this.range_params.containerColor) {
            this.range_params.containerColor = '#F7F7F7'
        }

        this.element.style.background = `linear-gradient(to right, ${this.range_params.backgroundColor} 0%, ${this.range_params.backgroundColor} ${(this.value-this.min)/(this.max-this.min)*100}%, ${this.range_params.containerColor} ${(this.value-this.min)/(this.max-this.min)*100}%, ${this.range_params.containerColor} 100%)`

        if (this.rangeWrapper.children.length >= 2) {
            if (this.rangeWrapper.children.length == 2 && this.rangeWrapper.children[1].classList.contains("k-range-text")) {
                this.range_value = this.rangeWrapper.children[1];
                this.range_value.children[0].style.color = this.range_params.color;
            } else if (this.rangeWrapper.children.length == 2 && !this.rangeWrapper.children[1].classList.contains("k-range-text")) {
                this.range_label = this.rangeWrapper.children[1];
            } else {
                this.range_value = this.rangeWrapper.children[1];
                this.range_label = this.rangeWrapper.children[2];
                this.range_value.children[0].style.color = this.range_params.color;
            }
            this.range_value.children[0].value = this.element.value;
        }
    }

    changebg() {
        this.element.style.background = `linear-gradient(to right, ${this.range_params.color} 0%, ${this.range_params.color} ${(this.value-this.min)/(this.max-this.min)*100}%, ${this.range_params.containerColor} ${(this.value-this.min)/(this.max-this.min)*100}%, ${this.range_params.containerColor} 100%)`;
    }

    defaultbg() {
        this.element.style.background = `linear-gradient(to right, ${this.range_params.backgroundColor} 0%, ${this.range_params.backgroundColor} ${(this.value-this.min)/(this.max-this.min)*100}%, ${this.range_params.containerColor} ${(this.value-this.min)/(this.max-this.min)*100}%, ${this.range_params.containerColor} 100%)`;
    }

    handleRangeValue() {
        this.value = this.element.value;
        if (this.range_value) {
            this.range_value.children[0].value = this.element.value;
        }
    }

    handleInputValue() {
        if(this.range_value.children[0]) {
            this.element.value = this.range_value.children[0].value;
            this.value = this.element.value;
            if (parseInt(this.range_value.children[0].value) > parseInt(this.max) ) {
                this.range_value.children[0].value = this.max
            }
            
            if (parseInt(this.range_value.children[0].value) <= parseInt(this.min) || this.range_value.children[0].value === '') {
                this.element.value = this.min
                this.value = this.min
            }
            this.element.style.background = `linear-gradient(to right, ${this.range_params.color} 0%, ${this.range_params.color} ${(this.value-this.min)/(this.max-this.min)*100}%, ${this.range_params.containerColor} ${(this.element.value-this.min)/(this.max-this.min)*100}%, ${this.range_params.containerColor} 100%)`
        }
    }

    activeDrag() {
        window.innerWidth <= 768 ? (
            this.element.style.background = `linear-gradient(to right, ${this.range_params.backgroundColor} 0%, ${this.range_params.backgroundColor} ${(this.value-this.min)/(this.max-this.min)*100}%, ${this.range_params.containerColor} ${(this.value-this.min)/(this.max-this.min)*100}%, ${this.range_params.containerColor} 100%)`
        ) : (
            this.element.style.background = `linear-gradient(to right, ${this.range_params.color} 0%, ${this.range_params.color} ${(this.value-this.min)/(this.max-this.min)*100}%, ${this.range_params.containerColor} ${(this.value-this.min)/(this.max-this.min)*100}%, ${this.range_params.containerColor} 100%)`
        )
    }

    getHeightOfLabel() {
        if(this.rangeWrapper.children[2].clientHeight > 16) {
            this.rangeWrapper.children[2].style.top = '-14px';
        }
    }

    disableRange() {
        if(this.rangeWrapper.classList.contains('disable')) {
            this.element.disabled = true;
            this.range_value.children[0].disabled = true;
        }
    }
}

let rangeInstances = [];

const init = (range_input, range_params) => {
    if (range_input) {
        if (typeof range_input.length == 'undefined') {
            const htmlElement = range_input;
            const parameters = range_params;
            rangeInstances = new kukunRange(htmlElement, parameters);
        } else {
            for (let i = 0; i < range_input.length; i++) {
                const htmlElement = range_input[i];
                const parameters = range_params;
                let rangeInstance = new kukunRange(htmlElement, parameters);
                rangeInstances.push(rangeInstance);
            }
        }
    }
    return rangeInstances;
}


export {
    init
};